import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue';
import store from '@/assets/common/store/store';
import { AgriFieldCultivationDetail, WorkRecordCultivationDetail, FertilizerWorkRelatedCultivationDetail, FertilizerDetailsByName, WorkRecordChemicals, ChemicalsByName, ChemicalsByTypes, FertlizersByTypes, ChemicalsGroupedByName, GroupedWorkRecord, GroupedChemicalsByTypes, FertilizersGroupedByName, GroupedWorkRecordFertilizers, FertilizerUsageDetail } from "@/types/Component";
import { changeDateFormat } from '../../services';
import { CsvDownload } from '@/types/APIResponse';

@Component({
    components: {
        Modal
    },
    filters: {
        changeDateFormat
    }
})
export default class CultivationHistoryPopup extends Vue {

    @Prop()
    isCultivationHistoryDetailShow!: boolean;

    @Prop()
    cultivationHistoryId!: string
    baseUrl = '/culitvation_history_detail';
    private agriFieldCultivationDetail: AgriFieldCultivationDetail | null = null;
    private workRecordCultivationDetail: WorkRecordCultivationDetail | null = null;
    private fertilizerWorkRelatedCultivationDetail: GroupedWorkRecordFertilizers[] = [];
    private fertilizerDetailsByName: FertilizersGroupedByName[] | null = null;
    private workRecordChemicals: GroupedWorkRecord[] = [];
    private chemicalsByName: ChemicalsGroupedByName[] | null = null;
    private chemicalsTypeDetails: GroupedChemicalsByTypes[] = [];
    private fertlizersTypeDetails: FertlizersByTypes | null = null;
    private isLoading = true;
    private globalChemicalAlerts: string[] = [];
    private globalFertilizerAlerts: string[] = [];
    private fertilizerTargetMessages = [
  '出荷品目で指定された窒素成分使用量に近づいています',
  '出荷品目で指定された窒素成分使用量を超過',
   ];


    @Watch('isCultivationHistoryDetailShow')
    onIshowChanged(newVal: boolean) {
        if (newVal) {
            this.getCultivationHistoryDetails();
        }
    }

    private async getCultivationHistoryDetails() {
        this.isLoading = true;
        try {
            await this.$apiClient.doRequest('get', `${this.baseUrl}/${this.cultivationHistoryId}`).then(res => {
                this.agriFieldCultivationDetail = res?.agriField as AgriFieldCultivationDetail;
                this.workRecordCultivationDetail = res?.workRecord as WorkRecordCultivationDetail;
                 this.fertilizerWorkRelatedCultivationDetail = this.groupWorkRecordFertilizers(res.workRecordFertilizers as FertilizerWorkRelatedCultivationDetail[]);
                this.fertilizerDetailsByName = this.groupByFertilizerName(res.fertilizersName as FertilizerDetailsByName[]);
                this.workRecordChemicals = this.groupWorkRecordChemicals(res.workRecordChemicals);
                const chemicalRecords = res.chemicalsName as ChemicalsByName[];
                const groupedMap = new Map<string, ChemicalsByName[]>();
                const alertSet = new Set<string>();
                const targetMessages = [
                        '出荷品目で指定された農薬の使用回数を超過',
                        '出荷品目で指定された農薬の使用回数に近づいています',
                ];
                chemicalRecords.forEach(record => {
                    const name = record.chemicalName;
                    const alert = record.alert;
                if (alert) {
                    alert.split('::').forEach(msg => {
                const trimmed = msg.trim();
                if (targetMessages.includes(trimmed)) {
                alertSet.add(trimmed);
                }
            });
            }
        if (!groupedMap.has(name)) {
          groupedMap.set(name, []);
        }
        groupedMap.get(name)!.push(record);
      });
      this.globalChemicalAlerts = Array.from(alertSet);
      this.chemicalsByName = Array.from(groupedMap.entries()).map(([chemicalName, usageDetails]) => {
        const rawAlert = usageDetails[0]?.alert || '';
        const remainingAlerts = rawAlert
          .split('::')
          .map(msg => msg.trim())
          .filter(msg => msg && !targetMessages.includes(msg));
        return {
          chemicalName,
          usageDetails,
          alert: remainingAlerts.length > 0 ? remainingAlerts.join('::') : null,
        };
      });

       const fertilizerGroupedMap = new Map<string, FertilizerDetailsByName[]>();
      const fertilizerAlertSet = new Set<string>();
      const fertilizerTargetMessages = [
        '出荷品目で指定された窒素成分使用量に近づいています',
        '出荷品目で指定された窒素成分使用量を超過',
      ];
        const fertilizerRecords = res.fertilizersName as FertilizerDetailsByName[];
      fertilizerRecords.forEach(record => {
        const name = record.fertilizerName;
        const alert = record.alert;

        if (alert) {
          alert.split('::').forEach(msg => {
            const trimmed = msg.trim();
            if (fertilizerTargetMessages.includes(trimmed)) {
              fertilizerAlertSet.add(trimmed);
            }
          });
        }

        if (!fertilizerGroupedMap.has(name)) {
          fertilizerGroupedMap.set(name, []);
        }
        fertilizerGroupedMap.get(name)!.push(record);
      });

      this.globalFertilizerAlerts = Array.from(fertilizerAlertSet);

      this.fertilizerDetailsByName = Array.from(fertilizerGroupedMap.entries()).map(([fertilizerName, usageDetails]) => {
        const rawAlert = usageDetails[0]?.alert || '';
        const remainingAlerts = rawAlert
          .split('、')
          .map(msg => msg.trim())
          .filter(msg => msg && !fertilizerTargetMessages.includes(msg));
        return {
          fertilizerName,
          usageDetails,
          alert: remainingAlerts.length > 0 ? remainingAlerts.join('、') : null,
        };
      });
        const rawRecords = res.chemicalsTypeDetails as ChemicalsByTypes[];
        this.chemicalsTypeDetails = this.groupChemicalsByName(rawRecords);
        this.fertlizersTypeDetails = res.fertlizersTypeDetails as FertlizersByTypes;
        });
        } finally {
            this.isLoading = false;
        }
    }

    private closeModal() {
        this.$store.dispatch("doUpdateIsInputChanged", false);
        this.$emit('update:isCultivationHistoryDetailShow', false);
        this.clearCultivationHistoryDatas()
    }

    private async clearCultivationHistoryDatas() {
        this.agriFieldCultivationDetail = null;
        this.workRecordCultivationDetail = null;
        this.fertilizerWorkRelatedCultivationDetail = [];
        this.fertilizerDetailsByName = null;
        this.workRecordChemicals = [];
        this.chemicalsByName = null;
        this.chemicalsTypeDetails = [];
        this.fertlizersTypeDetails = null;
        this.cultivationHistoryId = '';
    }

    csvDownload() {
        this.$apiClient.getRequest(`${this.baseUrl}/${this.cultivationHistoryId}/csv_export`).then((res: CsvDownload) => {
            this.$apiClient.csvDownload(res)
        }).catch(error => {
            this.$toasted.error('データの取得に失敗しました。')
        })
    }

    formatDigit(numberToFormat?: number): string {
        return typeof numberToFormat === 'number' ?
            numberToFormat.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: (numberToFormat % 1 !== 0) ? 2 : 0
            })
            : '';
    }

    formattedDate(date: string | Date | null): string {
        if (!date) return '';
        const d = new Date(date);
        if (isNaN(d.getTime())) return '';
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}.${mm}.${dd}`;
    }

    getDisinfectionLabel(value: string | null | undefined): string {
        if (value === null || value === undefined || value === '') {
            return '-';
        }
        switch (Number(value)) {
            case 3:
                return '種子';
            case 1:
                return '育苗中';
            case 2:
                return '本圃';
            default:
                return '-';
        }
    }

    groupWorkRecordChemicals(records: WorkRecordChemicals[]): GroupedWorkRecord[] {
        const groupedMap = new Map<string, GroupedWorkRecord>();

        records.forEach(record => {
            const key = record.workRecordId;

            if (!groupedMap.has(key)) {
                groupedMap.set(key, {
                    workRecordId: record.workRecordId,
                    workDate: record.workDate,
                    workItemName: record.workItemName,
                    usageDetails: [],
                });
            }

            const usageDetail = {
                chemicalName: record.chemicalName,
                disinfection: record.disinfection,
                dilutionRatio: record.dilutionRatio,
                amountSprayed: record.amountSprayed,
                amountUsed: record.amountUsed,
                amountSprayedPer10a: record.amountSprayedPer10a,
                amountUsedPer10a: record.amountUsedPer10a,
                dilRatioUnit: record.dilRatioUnit,
                sprayUnit: record.sprayUnit,
                usageUnit: record.usageUnit,
            };

            groupedMap.get(key)!.usageDetails.push(usageDetail);
        });

        return Array.from(groupedMap.values());
    }

    groupWorkRecordFertilizers(records: FertilizerWorkRelatedCultivationDetail[]): GroupedWorkRecordFertilizers[] {
        const groupedMap = new Map<string, GroupedWorkRecordFertilizers>();

        records.forEach(record => {
            const key = `${record.workDate}_${record.workItemName}`;

            if (!groupedMap.has(key)) {
                groupedMap.set(key, {
                    workRecordId: key,
                    workDate: record.workDate,
                    workItemName: record.workItemName,
                    usageDetails: [],
                });
            }

            const usageDetail: FertilizerUsageDetail = {
                fertilizerName: record.fertilizerName,
                usageUnit: record.usageUnit,
                usageCount: record.usagecount,
                usageQty: record.usageQty,
                usageQtyPer10a: record.usageQtyPer10a,
                usageChemicalCompositionAmount: record.usageChemicalCompositionAmount,
                usageChemicalCompositionAmountPer10a: record.usageChemicalCompositionAmountPer10a,
            };

            groupedMap.get(key)!.usageDetails.push(usageDetail);
        });

        return Array.from(groupedMap.values());
    }

    groupChemicalsByName(records: ChemicalsByTypes[]): GroupedChemicalsByTypes[] {
        const map = new Map<string, GroupedChemicalsByTypes>();

        records.forEach(record => {
            if (!map.has(record.chemicalTypeName)) {
                map.set(record.chemicalTypeName, {
                    chemicalTypeName: record.chemicalTypeName,
                    usageDetails: [],
                });
            }

            map.get(record.chemicalTypeName)!.usageDetails.push(record);
        });


        return Array.from(map.values());
    }

    groupByFertilizerName(list: FertilizerDetailsByName[] ): FertilizersGroupedByName[] {
        const groupedMap = new Map<string, FertilizerDetailsByName[]>();
        list.forEach((item) => {
            const key = item.fertilizerName;
            if (!groupedMap.has(key)) {
                groupedMap.set(key, []);
            }
            groupedMap.get(key)!.push(item);
        });
        const groupedArray: FertilizersGroupedByName[] = [];
        for (const [fertilizerName, usageDetails] of groupedMap) {
            groupedArray.push({ fertilizerName, usageDetails });
        }
        return groupedArray;
    }

    private uniqueAlert(details: any[]): string {
      if (!details || details.length === 0) return '';

      const allAlerts = details
        .filter((d: any) => d.alert && d.alert !== '-')
        .flatMap((d: any) => d.alert.split('::').map((msg: string) => msg.trim()));

      const unique = Array.from(new Set(allAlerts));
      const remaining = unique.filter(
        msg => !this.fertilizerTargetMessages.includes(msg)
      );

       return remaining.join('、');
    }

  uniqueAlertFert(usageDetails:any) {
    const alertSet = new Set();

    usageDetails.forEach((fert:any) => {
      if (fert.alert && fert.alert !== '-') {
        fert.alert.split('::').forEach((msg:any) => {
          alertSet.add(msg.trim());
        });
      }
    });

    return alertSet.size > 0 ? Array.from(alertSet).join('、') : null;
  }

  truncateText(text: string | null | undefined, maxLength: number): string {
    const safeText = text || '';
    if (safeText.length > maxLength) {
      return safeText.substring(0, maxLength) + '...';
    }
    return safeText;
  }
}
